(() => {
	const pagination = document.querySelector('.pagination');
	if (!pagination) {
		return;
	}

	const pageNumbers = pagination.querySelectorAll('.page-numbers');
	pageNumbers.forEach(element => {
		let number = parseInt(element.innerHTML);
		if (number < 10) {
			number = '0' + number;
			element.innerHTML = number;
		}
	});
})();
